import {
  forwardRef,
  useMergeRefs,
  PopoverContent as ChakraPopoverContent,
  PopoverArrow,
} from '@chakra-ui/react-v2';
import type { PopoverContentProps as ChakraPopoverContentProps } from '@chakra-ui/react-v2';
import { useMemo, useRef } from 'react';

import { OverlayContainerRefContextProvider } from '../OverlayContainerRefContext';
import { usePopoverContext } from './utils/PopoverContext';

export interface PopoverContentProps extends ChakraPopoverContentProps {
  hasArrow?: boolean;
}

export const PopoverContent = forwardRef<PopoverContentProps, 'section'>(
  ({ children, hasArrow: hasArrowProp, ...restProps }, forwardedRef) => {
    const containerRef = useRef<HTMLElement>(null);
    const mergedRefs = useMergeRefs(forwardedRef, containerRef);

    const { hasArrow: contextHasArrow } = usePopoverContext();
    const hasArrow = hasArrowProp ?? contextHasArrow;

    const containerRefContextValue = useMemo(() => {
      return {
        containerRef,
      };
    }, [containerRef]);

    return (
      <ChakraPopoverContent ref={mergedRefs} {...restProps}>
        {hasArrow && <PopoverArrow />}
        <OverlayContainerRefContextProvider value={containerRefContextValue}>
          {children}
        </OverlayContainerRefContextProvider>
      </ChakraPopoverContent>
    );
  },
);
PopoverContent.displayName = 'PopoverContent';
